class ApiClient {
    #apiUrl = import.meta.env.VITE_BACKEND_URL;
    #controllers = new Map();
    #token = null;

    setToken(token) {
        this.#token = token;
    }

    #params(params) {
        const searchParams = new URLSearchParams();
        if (params) {
            for (const [key, value] of Object.entries(params)) {
                searchParams.append(key, value);
            }
        }
        return searchParams.toString();
    }

    async #request({ caller, type, url, data, params }) {
        const controller = new AbortController();
        const signal = controller.signal;
        this.#controllers.set(caller, controller);

        url = `${this.#apiUrl}${url}`;
        if (params) {
            url = `${url}?${this.#params(params)}`;
        }

        const headers = {};
        if (!(data instanceof FormData)) {
            headers['Content-Type'] = 'application/json';
        }

        if (this.#token) {
            headers['Authorization'] = `Bearer ${this.#token}`;
        }

        try {
            const response = await fetch(url, {
                method: type,
                headers: headers,
                body: data instanceof FormData ? data : JSON.stringify(data),
                signal,
            });

            if (!response.ok) {
                // Read the response body to include in the error
                throw await response.json(); // Throw only the response body
            }

            return await response.json();
        } finally {
            this.#controllers.delete(caller);
        }
    }

    $abort() {
        for (const value of this.#controllers.values()) {
            value.abort();
        }
        this.#controllers.clear();
    }

    get(url, params) {
        return this.#request({ caller: 'get', type: 'GET', url, params });
    }

    post(url, data, params) {
        return this.#request({ caller: 'post', type: 'POST', data, url, params });
    }

    put(url, data, params) {
        return this.#request({ caller: 'put', type: 'PUT', data, url, params });
    }

    delete(url, params) {
        return this.#request({ caller: 'delete', type: 'DELETE', url, params });
    }
}

export default new ApiClient();
